'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @public
 * @param {Object} props
 * @param {ReactElement} prosp.children
 */
var Notes = function Notes(_ref) {
  var children = _ref.children;

  return typeof children === 'string' ? children : _react.Children.toArray(children).map(function (child, i) {
    return (0, _react.cloneElement)(child, { key: i });
  });
};

/**
 * @private
 */
Notes.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

exports.default = Notes;
//# sourceMappingURL=index.js.map